export var KeyboardEvents = {
    arrowDown: 'ArrowDown',
    arrowLeft: 'ArrowLeft',
    arrowRight: 'ArrowRight',
    arrowUp: 'ArrowUp',
    enter: 'Enter',
    escape: 'Escape',
    space: ' ',
    tab: 'Tab',
};
//# sourceMappingURL=index.js.map